import styled from "@emotion/styled";
import { Box, Button, colors, Typography, useTheme } from "@mui/material";
import { Stack } from "@mui/system";
import React, { useState } from "react";
import { blueTick, dummyNft6 } from "../../assets";
import { tokens } from "../../theme";
import Topbar from "../global/Topbar";
import BasicSelect from "./components/Select";
import NftDetails from "./components/NftDetails";
import YieldSplit from "./components/YieldSplit";
import SendView from "./components/SendView";
import { useParams } from "react-router-dom";
import { useTypedSelector } from "../../hooks/useTypedSelector";

const OverviewWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  paddingLeft: "20px",
  width: "80vw",
  // height: "100%",
  position: "relative",
}));

const StyledButton = styled(Button)(({ theme, colors }) => ({
  backgroundColor: colors.whiteAccent[900],
  color: colors.primary[500],
  fontSize: "14px",
  fontWeight: 400,
  width: "48%",
  height: "40px",
  borderRadius: "7px",
  borderColor: colors.primary[500],
  "&:hover": {
    backgroundColor: colors.primary[600],
    borderColor: colors.primary[500],
    color: colors.whiteAccent[900],
  },
}));

const Index = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [step, setStep] = useState(0);

  return (
    <OverviewWrapper>
      {/* <Box sx={{ width: "100%" }}>
        <Topbar />
      </Box> */}
      {step === 0 && <NftDetails setStep={setStep} />}
      {step === 1 && <YieldSplit setStep={setStep} />}
      {step === 2 && <SendView setStep={setStep} />}
    </OverviewWrapper>
  );
};

export default Index;
